module.exports = __webpack_public_path__ + "static/img/resolvent3.bf4576d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/resolvent3.png
// module id = Ww2N
// module chunks = 13